// 有背景版本
export function fileClass(formatType) {
  const index = formatType.lastIndexOf('.')
  index !== -1 && (formatType = formatType.slice(index + 1))
  const mimetype = {
    doc: 'file-doc',
    docx: 'file-doc',
    jpg: 'file-pic',
    png: 'file-pic',
    picture: 'file-pic',
    jpeg: 'file-pic',
    pdf: 'file-pdf',
    xls: 'file-xls',
    xlsx: 'file-xls',
    ppt: 'file-ppt',
    txt: 'file-txt',
    pptx: 'file-ppt',
    rar: 'file-zip',
    mp3: 'file-audio',
    mp4: 'file-video',
    avi: 'file-video',
    mov: 'file-video',
    rmvb: 'file-video',
    flv: 'file-video',
    vs4: 'file-video',
    wma: 'file-video',
  }
  const type = formatType && formatType.toLowerCase()
  return mimetype[type] ? mimetype[type] : 'file-other'
}

export const escape2Html = (str) => {
  const arrEntities = {
    lt: '<',
    gt: '>',
    nbsp: ' ',
    amp: '&',
    quot: '"',
    mdash: '—',
    ldquo: '“',
    rdquo: '”',
    rsquo: '’',
    lsquo: '‘',
    permil: '‰',
    euro: '€',
    le: '≤',
    ge: '≥',
    ne: '≠',
    middot: '·',
    trade: '™',
    '\\n': ' ',
  }
  return str.replace(
    /&(lt|gt|nbsp|amp|quot|mdash|ldquo|rdquo|rsquo|lsquo|permil|euro|le|ge|ne|middot|trade);|(\\n)/gi,
    (all, t, d) => {
      return arrEntities[t] || arrEntities[d]
    },
  )
}

export const imgCoverMap = {
  'file-pic': require('@/assets/icon/imgIcon.png'),
  'file-pdf': require('@/assets/icon/pdfIcon.png'),
  'file-xls': require('@/assets/icon/excelIcon.png'),
  'file-doc': require('@/assets/icon/docIcon.png'),
  'file-video': require('@/assets/icon/videoIcon.png'),
  'file-audeo': require('@/assets/icon/audioIcon.png'),
  'file-other': require('@/assets/icon/otherIcon.png'),
  'file-ppt': require('@/assets/icon/pptIcon.png'),
  'file-txt': require('@/assets/icon/txt.png'),
  'file-audio': require('@/assets/icon/audioIcon.png'),
  'file-zip': require('@/assets/icon/zip.png'),
  'empty-img': require('@/assets/empty.svg'),
}
export const getObjType = (obj) => {
  const { toString } = Object.prototype
  const map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object',
  }
  if (obj instanceof Element) {
    return 'element'
  }
  return map[toString.call(obj)]
}

/**
 * 对象深拷贝
 */
export const deepClone = (data) => {
  const type = getObjType(data)
  let obj
  if (type === 'array') {
    obj = []
  } else if (type === 'object') {
    obj = {}
  } else {
    // 不再具有下一层次
    return data
  }
  if (type === 'array') {
    for (let i = 0, len = data.length; i < len; i++) {
      obj.push(deepClone(data[i]))
    }
  } else if (type === 'object') {
    for (const key in data) {
      // eslint-disable-next-line no-prototype-builtins
      if (data.hasOwnProperty(key)) {
        obj[key] = deepClone(data[key])
      }
    }
  }
  return obj
}

export function getFileType(url) {
  // 后缀获取
  let suffix = ''
  // 获取类型结果
  let result = ''
  try {
    const filesArr = url.split('.')
    suffix = filesArr[filesArr.length - 1]
  } catch (err) {
    suffix = ''
  }
  // url无后缀
  if (!suffix) {
    // 其他 文件类型
    return { type: 'unknown', icon: 'file-other', key: 6 }
  }
  suffix = suffix.toLocaleLowerCase()
  // 匹配 image
  const imageList = ['png', 'jpg', 'svg', 'gif', 'jpeg', 'raw', 'bmp', 'tiff', 'webp']
  result = imageList.find((item) => item === suffix)
  if (result) {
    return { type: 'image', icon: 'file-image', key: 2 }
  }
  // 匹配 excel
  const excelList = ['xls', 'xlsx']
  result = excelList.find((item) => item === suffix)
  if (result) {
    return { type: 'excel', icon: 'file-excel', key: 1 }
  }
  // 匹配 word
  const wordList = ['doc', 'docx']
  result = wordList.find((item) => item === suffix)
  if (result) {
    return { type: 'word', icon: 'file-doc', key: 1 }
  }
  // 匹配 pdf
  const pdfList = ['pdf']
  result = pdfList.find((item) => item === suffix)
  if (result) {
    return { type: 'pdf', icon: 'file-pdf', key: 1 }
  }
  // 匹配 ppt
  const pptList = ['ppt', 'pptx']
  result = pptList.find((item) => item === suffix)
  if (result) {
    return { type: 'ppt', icon: 'file-ppt', key: 1 }
  }
  // 匹配 video
  const videoList = ['mp4', 'mpeg', 'avi', 'mov', 'flv', 'webm', 'mpg', '3gp', 'wmv']
  result = videoList.find((item) => item === suffix)
  if (result) {
    return { type: 'video', icon: 'file-video', key: 3 }
  }
  // 匹配 audio
  const audioList = ['mp3', 'mid', 'wav', 'm3u', 'm4a', 'ogg']
  result = audioList.find((item) => item === suffix)
  if (result) {
    return { type: 'audio', icon: 'file-audio', key: 4 }
  }
  // 匹配 压缩包
  const zipList = ['zip', 'rar', '7z']
  result = zipList.find((item) => item === suffix)
  if (result) {
    return { type: 'zip', icon: 'file-zip', key: 5 }
  }
  // 其他 文件类型
  return { type: 'other', icon: 'file-other', key: 6 }
}

/**
 * 日期格式化
 */
export function dateFormat(date, newFormat) {
  let format = newFormat || 'yyyy-MM-dd hh:mm:ss'
  if (date !== 'Invalid Date') {
    let o = {
      'M+': date.getMonth() + 1, // month
      'd+': date.getDate(), // day
      'h+': date.getHours(), // hour
      'm+': date.getMinutes(), // minute
      's+': date.getSeconds(), // second
      'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
      S: date.getMilliseconds(), // millisecond
    }
    if (/(y+)/.test(format)) {
      format = format.replace(RegExp.$1, String(date.getFullYear()).substr(4 - RegExp.$1.length))
    }
    for (let k in o) {
      if (new RegExp('(' + k + ')').test(format)) {
        format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(String(o[k]).length))
      }
    }
    return format
  }
  return ''
}

// 指定长度随机数生成
export function getRandomString(length) {
  let result = ''
  let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let charactersLength = characters.length
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

// 时间格式化
export function formatSuitData(time) {
  if (time > 0) {
    let hours = parseInt(time / 3600, 10)
    let seconds = time - hours * 3600
    let minutes = parseInt(seconds / 60, 10)
    seconds = seconds - minutes * 60
    if (hours > 0) {
      hours = hours + '小时'
    } else {
      hours = ''
    }
    if (minutes > 0) {
      minutes = minutes + '分'
    } else {
      minutes = ''
    }
    if (seconds > 0) {
      seconds = seconds + '秒'
    } else {
      seconds = ''
    }

    return hours + minutes + seconds
  } else {
    return 0
  }
}

export function isJson(str) {
  if (typeof str === 'string') {
    try {
      const obj = JSON.parse(str)
      if (typeof obj === 'object' && obj) {
        return true
      }
      return false
    } catch (error) {
      return false
    }
  }
  return new Error('its not a string')
}
